import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';
import { AuthenticationService, UtilityService, ValidationService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models/userprofile';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { UserEditService } from './shared';
import { USER_EDIT_HEADER_CLASS, USER_EDIT_HEADER_TYPE } from './user-edit.config';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot';

declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html
import { BREADCRUMBS } from 'config';
declare var logoutCurrentUser: any;

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss'],
  providers: [ValidationService, UserEditService, AdobeAnalyticsService], // utilityService is provided in app component already
  encapsulation: ViewEncapsulation.None
})

export class UserEditComponent implements OnInit {
  breadCrumbs: BreadCrumbModel[];
  setError = false;
  ErrorMessage: string;
  userEditform: FormGroup;
  showProduct: boolean;
  userInfo: UserProfileModel;
  productLisenceInfo: Array<string>;
  initFirstName = '';
  initLastName = '';
  initEmail = '';
  initContact = '';
  id: string;
  user: UserProfileModel;
  userSummaryProductModelArr: Array<Object>;
  previousRoute: any;
  csrPermissionSaveButton: boolean;
  pivots: Array<MobilePivotModel>;
  emailFlag = false;
  formErrors = {
    'firstName': '',
    'lastName': '',
    'email': '',
    'phoneNumber': ''
  };
  validationMessages = {
    'firstName': {
      'required': 'First name is required.',
      'pattern': 'Please enter a valid first name.'
    },
    'lastName': {
      'required': 'Last name is required.',
      'pattern': 'Please enter a valid last name.'
    },
    'email': {
      'required': 'Email is required.',
      'pattern': 'Please enter a valid Email id.'
    },
    'phoneNumber': {
      'required': 'Phone number is required.',
      'checkPattern': 'Please enter a valid 10 digit contact number (XXXXXXXXXX).'
    }
  };

  constructor(private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private utilityService: UtilityService,
    private userEditService: UserEditService,
    private formBuilder: FormBuilder,
    private validationService: ValidationService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private http: HttpClient, private pageloaderService: PageLoaderService, private breadCrumbService: BreadCrumbService) {
    this.csrPermissionSaveButton = this.utilityService.checkFieldPermission('userEdit.save',
    JSON.parse(sessionStorage.getItem('permissions')).perm);
    this.pivots = new Array<MobilePivotModel>();

  }

  ngOnInit() {
    let url = this.router.routerState.snapshot.url;
    const updatedUrl = url.substring(0, url.lastIndexOf('/'));
    document.title = this.utilityService.getPageTitleConfig()[updatedUrl];
    this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    if (this.authenticationService.getUser() === null) {
      // this.router.navigate(['login']);
      window.location.href = '/businessconsole/login';
    }
    this.showProduct = true;
    this.id = this.route.snapshot.params['id'];
    this.user = this.authenticationService.getUser();
    this.previousRoute = this.breadCrumbService.getLastUrlFromBreadCrumb();
    this.getUserInfo();
    this.buildForm();
    this.userEditService.createPageLoadProperties(this.router.routerState.snapshot.url,
      'User Edit');
  }

  getUserInfo() {
    const tmpUser = JSON.parse(sessionStorage.getItem('user-manage-' + this.id));
    if (tmpUser !== null && tmpUser.user_info !== undefined) {
      this.initFirstName = tmpUser.user_info.firstName;
      this.initLastName = tmpUser.user_info.lastName;
      this.initEmail = tmpUser.user_info.email;
      this.initContact = tmpUser.user_info.contactNumber.split('.').join('');
      this.initContact = this.utilityService.formatTelephoneNumber(this.initContact);
      this.breadCrumbService.setCurrentBreadCrumb({ 'label': 'Edit user', 'routerLink': this.router.routerState.snapshot.url });
      this.userSummaryProductModelArr = tmpUser.userSummaryProductModelArr;
      if (this.userSummaryProductModelArr.length !== 0) {
        this.showProduct = true;
      } else {
        this.showProduct = false;
      }
      console.log(this.userSummaryProductModelArr);
    } else {
      this.router.navigate(['user/summary' + '/' + this.id]);
    }
  }

  contactChange(event) {
    event = Object(event);
    if (event) {
      if (event.keyCode === 46) {
        // not to except .
        event.preventDefault();
      }
    }
  }

  contactBlur(event) {
    if (event.target.value.match('^[0-9]{1,100}$')) {
      var val = this.utilityService.onBlurFormat(event.target.value, 'dot');
      this.userEditform.get('phoneNumber').setValue(val);
    }
  }

  contactFocus(event) {
    var val = this.utilityService.onFocusFormat(event.target.value, 'dot');
    this.userEditform.get('phoneNumber').setValue(val);
  }

  buildForm() {
    this.userEditform = this.formBuilder.group({
      firstName: [this.initFirstName,
      [Validators.required, Validators.pattern(/(?!^\s+$)^.+$/)]],
      lastName: [this.initLastName,
      [Validators.required, Validators.pattern(/(?!^\s+$)^.+$/)]],
      email: [this.initEmail,
      [Validators.required,
      Validators.pattern(`^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$`)]],
      phoneNumber: [this.initContact,
      [Validators.required,
      this.utilityService.validatePhoneNumber]]
    });

    this.validationService.validate(
      this.userEditform,
      this.formErrors,
      this.validationMessages);
  }

  updateUserInfo() {
    var body_msg = this.userEditform.value;
    body_msg.phoneNumber = body_msg.phoneNumber.split('.').join('');

    body_msg.class = USER_EDIT_HEADER_CLASS;
    body_msg.optimistic = 0;
    body_msg.type = USER_EDIT_HEADER_TYPE;
    this.userEditService.saveUserInfo(
      this.utilityService.getEnvConfig().userEdit + this.user.companyId + '/employees/' + this.id, body_msg)
      .subscribe(respobj => {
        if (respobj) {
          this.setError = false;
          this.ErrorMessage = '';
          this.breadCrumbService.removeLastBreadCrumb();
          this.breadCrumbService.removeLastBreadCrumb();
          this.router.navigate([this.previousRoute.routerLink]);
        }
      },
      err => {
        this.adobeAnalyticsService.CreateSeriveAlertProperties(err.status, err.statusText, 'formResponse');
        if (err.status === 401) {
          this.setError = true;
          this.ErrorMessage = 'Session Expired.Please login again.';
          logoutCurrentUser(true);
        } else if (err.status === 400) {
          this.setError = true;
          this.emailFlag = true;
          this.ErrorMessage = 'This email address is already in use. Enter a different email address.';
        } else {
          this.setError = true;
          this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
        }
        this.utilityService.loadFocusOnTop();
      }
      );
  }

  back() {
    this.router.navigate([sessionStorage.getItem('previousRoute')]);
    // this.router.navigate([this.utilityService.getParentUrl(this.router.url)]);
  }

  toggleTooltip(event) {
    const targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

}
